// export const base_path = "/react/template/";
import { getUrls } from "./api/apiurls.js";
export const base_path = "/";
export const bucketObj = {
    // bucketName: 'pub-uploads', // bucket Name 
   // bucketName: 'raw-stg-uploads', // bucket Name 
    objectKey: getUrls().objectKey,//'uploads/',
    get bucketUrl() {
        return getUrls().bucketUrl;//`https://raw-stg-uploads.s3.me-south-1.amazonaws.com/`;
    }
};